/**
 * Chart.js theme, resolved from the design tokens in tokens.css.
 *
 * Chart.js paints to a canvas, so it cannot consume `var(--token)` — it needs
 * a resolved color string. This reads the live custom property values and
 * falls back to the token's literal value if the stylesheet hasn't landed yet.
 *
 * Call it at chart-build time, not at module scope, so the values are read
 * after tokens.css has been applied.
 *
 * Spec: /DESIGN.md — The Floor Rule (nothing dimmer than #7d8695 carries text)
 */

function read(name, fallback) {
  if (typeof window === 'undefined' || !document?.documentElement) return fallback;
  const value = getComputedStyle(document.documentElement)
    .getPropertyValue(name)
    .trim();
  return value || fallback;
}

export default function chartTheme() {
  return {
    /** Axis tick labels. Was '#888' (4.48:1) — just under AA. */
    tick: read('--text-muted', '#9ca3af'),

    /**
     * Axis titles and legend labels. Was '#555' (2.13:1) — effectively
     * unreadable, and dimmer than the ticks it labelled. Titles outrank
     * ticks, so they now sit one step brighter.
     */
    title: read('--text-secondary', '#d1d5db'),

    /** Grid lines. Non-text, so the 3:1 floor does not apply. */
    grid: 'rgba(255, 255, 255, 0.08)',

    /** Body face, for tick and legend text. */
    fontFamily: read('--font-sans', "'Nunito', sans-serif"),
  };
}
